import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface GlCodeSummaryResponse {
  glCode: string;
  glCodeDescription: string;
  subTotalAmount: number;
  discountAmount: number;
  shippingAmount: number;
  taxesAmount: number;
  totalAmount: number;
  beginBalanceAmount: number;
  endingBalanceAmount: number;
  isOverBudget: number;
  glBudgetId: number;
  glPeriodId: number;
  glCodeId: number;
  glCodeContent: string;
  distributionPercentage: number;
  distributionAmount: number;
}

const useGlCodeSummaryApi = (poId: string) => {
  const call = useCallback(
    () =>
      new Promise<GlCodeSummaryResponse[]>((resolve, reject) => {
        axiosInstance
          .get<GlCodeSummaryResponse[]>(api.getGlCodeSummary(poId))
          .then((res) => {
            const data = res.data.map((item) => ({
              ...item,
              glCodeContent: `${item.glCode}-${item.glCodeDescription}`,
              distributionPercentage: 0,
              distributionAmount: 0,
            }));
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    [poId]
  );
  const { isLoading, value, setValue, execute } = useAsync(call, true);
  return {
    glCodeSummary: value,
    setGlCodeSummary: setValue,
    getGlCodeSummary: execute,
    isSummaryLoading: isLoading,
  };
};

export default useGlCodeSummaryApi;
